export function generateHash(name) {
    let hash = 0;
    
    for (let i = 0; i < name.length; i++) {
      hash += name.charCodeAt(i);
    }
    
    hash %= 10000; // Limitar el hash a 4 dígitos
    
    const hashString = hash.toString().padStart(4, '0');
    
    return hashString;
}

export const generateDailyCode = () => {
  const currentDate = new Date();
  const year = String(currentDate.getFullYear()).slice(-2);
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  console.log(day)
  // Intercambio de números en un orden específico
  const code = month[1] + day[0]  + day[1] + year[1] + month[0];

  return code;
};
